/** Used to lookup unminified function names. */
var realNames = {};

module.exports = realNames;



/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/~/lodash/_realNames.js
 ** module id = 2733
 ** module chunks = 0
 **/